import Home from '@/app/page';
import Aktualis from '@/app/aktualis/page';
import Versenyzoink from '@/app/versenyzoink/page';
import Media from '@/app/media/page';
import Jelentkezes from '@/app/jelentkezes/page';
import Bemutatkozas from '@/app/bemutatkozas/page';
import Tamogatok from '@/app/tamogatok/page';
import Palyazatok from '@/app/palyazatok/page';
export const routes = { '/': Home, '/aktualis': Aktualis, '/versenyzoink': Versenyzoink, '/media': Media, '/jelentkezes': Jelentkezes, '/bemutatkozas': Bemutatkozas, '/tamogatok': Tamogatok, '/palyazatok': Palyazatok };
